module.exports = __webpack_public_path__ + "img/menu-info.d6c9f852.svg";